import {
  ModifiedAnswerOption,
  ModifiedQuestion,
} from '@/client/quizzes/types/quizzes.type';

const SECURITY_PROFILE_QUESTION_KEY_PREFIX = 'securityProfile.question';

export const getSecurityProfileQuestionKey = (
  question: Pick<ModifiedQuestion, 'key'> | undefined,
): string | null =>
  question?.key
    ? `${SECURITY_PROFILE_QUESTION_KEY_PREFIX}.${question.key}`
    : null;

export const getSecurityProfileAnswerOptionKey = (
  question: Pick<ModifiedQuestion, 'key'> | undefined,
  answerOption: Pick<ModifiedAnswerOption, 'key'> | undefined,
): string | null => {
  const questionKey = getSecurityProfileQuestionKey(question);

  return questionKey && answerOption?.key
    ? `${questionKey}.option.${answerOption.key}`
    : null;
};
